export var EventTypeEnum;
(function (EventTypeEnum) {
    EventTypeEnum[EventTypeEnum["Family"] = 1] = "Family";
    EventTypeEnum[EventTypeEnum["Director"] = 2] = "Director";
    EventTypeEnum[EventTypeEnum["Individual"] = 3] = "Individual";
    EventTypeEnum[EventTypeEnum["Group"] = 4] = "Group";
    EventTypeEnum[EventTypeEnum["All"] = 5] = "All";
})(EventTypeEnum || (EventTypeEnum = {}));
